import React from 'react';
import { Header } from '../components/Header';
import {Footer} from '../components/Footer';
import { CircleCheckBig, House, Package, Recycle, Truck, FileCheck, Coins, Motorbike, Wrench, MapPin } from 'lucide-react';
import { NavLink } from 'react-router-dom';


const Services = () => {

  return (
			<div>
				<Header></Header>
				<br />
				<center>
					<h2>
						<span class='badge rounded-pill text-danger text-bg-danger bg-opacity-50'>Nos Services</span>
					</h2>
					<br />
					<h1>Tous vos besoins en un seul contact</h1>
					<br />
					<p>Dépannage, épaviste et débarras : une solution complète pour tous vos projets</p>
					<br />
					<div class='card border-0' style={{ maxWidth: '73rem' }}>
						<div class='card-body'>
							<ul class='nav nav-tabs justify-content-center'>
								<li class='nav-item'>
									<a class='nav-link active' data-toggle='tab' href='#home'>
										🚗 Dépannage
									</a>
								</li>
								<li class='nav-item'>
									<a class='nav-link' data-toggle='tab' href='#menu1'>
										🔧 Épaviste
									</a>
								</li>
								<li class='nav-item'>
									<a class='nav-link' data-toggle='tab' href='#menu2'>
										📦 Débarras
									</a>
								</li>
							</ul>
							<br />
							<div class='tab-content'>
								<div class='tab-pane container active' id='home'>
									<div class='container'>
										<div class='row'>
											<div class='col-sm'>
												<div class='card border border-danger shadow' style={{ width: '18rem' }}>
													<div class='card-body text-start'>
														<span class='badge text-bg-danger bg-opacity-25'>
															<Wrench color='#f7021b' />
														</span>
														<br />
														<br />
														<h5 class='card-title'>Dépannage Auto 24/7</h5>
														<br />
														<p class='card-text'>Intervention rapide pour panne mécanique, batterie à plat, crevaison ou perte de clés.</p>
													</div>
												</div>
											</div>
											<div class='col-sm'>
												<div class='card border border-danger shadow' style={{ width: '18rem' }}>
													<div class='card-body text-start'>
														<span class='badge text-bg-danger bg-opacity-25'>
															<Motorbike color='#f7021b' />
														</span>
														<br />
														<br />
														<h5 class='card-title'>Dépannage Moto</h5>
														<br />
														<p class='card-text'>Service spécialisé pour le dépannage et le transport de votre deux-roues.</p>
													</div>
												</div>
											</div>
											<div class='col-sm'>
												<div class='card border border-danger shadow' style={{ width: '18rem' }}>
													<div class='card-body text-start'>
														<span class='badge text-bg-danger bg-opacity-25'>
															<Truck color='#f7021b' />
														</span>
														<br />
														<br />
														<h5 class='card-title'>Remorquage</h5>
														<br />
														<p class='card-text'>Transport de votre véhicule vers le garage de votre choix ou votre domicile.</p>
													</div>
												</div>
											</div>
										</div>
										<br />
										<div class='row'>
											<div class='card text-bg-primary p-3 text-center'>
												<div class='card-body'>
													<h5 class='card-title'>⚡ Service 24h/24 - 7j/7</h5>
													<p class='card-text'>Une panne à 3h du matin ? Pas de problème ! Notre équipe intervient jour et nuit.</p>
													<button type='button' class='btn btn-light text-primary btn-lg'>
														<a href='tel:0618767935' style={{ textDecoration: 'none' }}>
															06 18 76 79 35
														</a>
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class='tab-pane container fade' id='menu1'>
									<div class='container'>
										<div class='row'>
											<div class='col-sm'>
												<div class='card border border-danger shadow' style={{ width: '18rem' }}>
													<div class='card-body text-start'>
														<span class='badge text-bg-danger bg-opacity-25'>
															<Truck color='#f7021b' />
														</span>
														<br />
														<br />
														<h5 class='card-title'>Enlèvement gratuit</h5>
														<br />
														<p class='card-text'>Récupération gratuite de votre véhicule hors d'usage partout au Pays Basque.</p>
													</div>
												</div>
											</div>
											<div class='col-sm'>
												<div class='card border border-danger shadow' style={{ width: '18rem' }}>
													<div class='card-body text-start'>
														<span class='badge text-bg-danger bg-opacity-25'>
															<FileCheck color='#f7021b' />
														</span>
														<br />
														<br />
														<h5 class='card-title'>Certificat de destruction</h5>
														<br />
														<p class='card-text'>Délivrance immédiate du certificat de destruction conforme à la réglementation.</p>
													</div>
												</div>
											</div>
											<div class='col-sm'>
												<div class='card border border-danger shadow' style={{ width: '18rem' }}>
													<div class='card-body text-start'>
														<span class='badge text-bg-danger bg-opacity-25'>
															<Coins color='#f7021b' />
														</span>
														<br />
														<br />
														<h5 class='card-title'>Rachat d'épave</h5>
														<br />
														<p class='card-text'>Rachat de votre véhicule selon son état et les cours des métaux.</p>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class='tab-pane container fade' id='menu2'>
									<div class='container'>
										<div class='row'>
											<div class='col-sm'>
												<div class='card border border-danger shadow' style={{ width: '18rem' }}>
													<div class='card-body text-start'>
														<span class='badge text-bg-danger bg-opacity-25'>
															<House color='#f7021b' />
														</span>
														<br />
														<br />
														<h5 class='card-title'>Vide maison complet</h5>
														<br />
														<p class='card-text'>Débarras intégral de maison, appartement, cave ou grenier.</p>
													</div>
												</div>
											</div>
											<div class='col-sm'>
												<div class='card border border-danger shadow' style={{ width: '18rem' }}>
													<div class='card-body text-start'>
														<span class='badge text-bg-danger bg-opacity-25'>
															<Package color='#f7021b' />
														</span>
														<br />
														<br />
														<h5 class='card-title'>Évacuation encombrants</h5>
														<br />
														<p class='card-text'>Enlèvement de meubles, électroménager et tout type d'encombrants.</p>
													</div>
												</div>
											</div>
											<div class='col-sm'>
												<div class='card border border-danger shadow' style={{ width: '18rem' }}>
													<div class='card-body text-start'>
														<span class='badge text-bg-danger bg-opacity-25'>
															<Recycle color='#f7021b' />
														</span>
														<br />
														<br />
														<h5 class='card-title'>Tri et recyclage</h5>
														<br />
														<p class='card-text'>Tri sélectif et valorisation des déchets dans le respect de l'environnement.</p>
													</div>
												</div>
											</div>
										</div>
										<br />
										<div class='row'>
											<div class='col-sm-6'>
												<div class='card bg-gradient' style={{ backgroundColor: '#a804f9' }}>
													<div class='card-body text-start text-light'>
														<h5 class='card-title'>🏠 Vide maison</h5>• Succession et héritage
														<br />• Déménagement
														<br />• Cave et grenier
														<br />• Débarras après sinistre
													</div>
												</div>
											</div>
											<div class='col-sm-6'>
												<div class='card bg-gradient' style={{ backgroundColor: '#F54927' }}>
													<div class='card-body text-start text-light'>
														<h5 class='card-title'>♻️ Encombrants</h5>• Meubles et mobilier
														<br />• Électroménager
														<br />• Matelas et literie
														<br />• Gravats et déchets
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<br />
					<br />
					<h2>
						<span class='badge rounded-pill text-danger text-bg-danger bg-opacity-50'>Zone d'Intervention</span>
					</h2>
					<br />
					<h1>Intervention Pays Basque, Landes & Béarn</h1>
					<br />
					<div class='container'>
						<div class='row'>
							<div class='col-sm'>
								<div class='card' style={{ width: '18rem' }}>
									<div class='card-body'>
										<div class='container'>
											<div class='row'>
												<div class='col-sm-2'>
													<span class='badge text-bg-danger bg-opacity-25'>
														<MapPin color='#f7021b' />
													</span>
												</div>
												<div class='col-sm-10 text-start'>
													<h5 class='card-title'>Pays Basque</h5>
													<h6 class='card-subtitle mb-2 text-body-secondary'>Pyrénées-Atlantiques (64)</h6>
												</div>
											</div>
										</div>
										<p class='card-text text-start'>
											<CircleCheckBig color='#239f38' size={16} /> Bayonne
											<br />
											<CircleCheckBig color='#239f38' size={16} /> Biarritz
											<br />
											<CircleCheckBig color='#239f38' size={16} /> Anglet
											<br />
											<CircleCheckBig color='#239f38' size={16} /> Saint-Jean-de-Luz
											<br />
											<CircleCheckBig color='#239f38' size={16} /> Hendaye
											<br />
											<CircleCheckBig color='#239f38' size={16} /> Bidart
											<br />
											<CircleCheckBig color='#239f38' size={16} /> Guéthary
											<br />
											<CircleCheckBig color='#239f38' size={16} /> Ciboure
											<br />
											<CircleCheckBig color='#239f38' size={16} /> Urrugne
											<br />
											<CircleCheckBig color='#239f38' size={16} /> Cambo-les-Bains
										</p>
									</div>
								</div>
							</div>
							<div class='col-sm'>
								<div class='card' style={{ width: '18rem' }}>
									<div class='card-body'>
										<div class='container'>
											<div class='row'>
												<div class='col-sm-2'>
													<span class='badge text-bg-danger bg-opacity-25'>
														<MapPin color='#f7021b' />
													</span>
												</div>
												<div class='col-sm-10 text-start'>
													<h5 class='card-title'>Béarn</h5>
													<h6 class='card-subtitle mb-2 text-body-secondary'>Pyrénées-Atlantiques (64)</h6>
												</div>
											</div>
										</div>
										<p class='card-text text-start'>
											<CircleCheckBig color='#239f38' size={16} /> Pau
											<br />
											<CircleCheckBig color='#239f38' size={16} /> Oloron-Sainte-Marie
											<br />
											<CircleCheckBig color='#239f38' size={16} /> Orthez
											<br />
											<CircleCheckBig color='#239f38' size={16} /> Lescar
											<br />
											<CircleCheckBig color='#239f38' size={16} /> Billère
											<br />
											<CircleCheckBig color='#239f38' size={16} /> Jurançon
											<br />
											<CircleCheckBig color='#239f38' size={16} /> Bizanos
											<br />
											<CircleCheckBig color='#239f38' size={16} /> Lons
											<br />
											<CircleCheckBig color='#239f38' size={16} /> Mourenx
											<br />
											<CircleCheckBig color='#239f38' size={16} /> Salies-de-Béarn
										</p>
									</div>
								</div>
							</div>
							<div class='col-sm'>
								<div class='card' style={{ width: '18rem' }}>
									<div class='card-body'>
										<div class='container'>
											<div class='row'>
												<div class='col-sm-2'>
													<span class='badge text-bg-danger bg-opacity-25'>
														<MapPin color='#f7021b' />
													</span>
												</div>
												<div class='col-sm-10 text-start'>
													<h5 class='card-title'>Landes</h5>
													<h6 class='card-subtitle mb-2 text-body-secondary'>Landes (40)</h6>
												</div>
											</div>
										</div>
										<p class='card-text text-start'>
											<CircleCheckBig color='#239f38' size={16} /> Dax
											<br />
											<CircleCheckBig color='#239f38' size={16} /> Mont-de-Marsan
											<br />
											<CircleCheckBig color='#239f38' size={16} /> Biscarrosse
											<br />
											<CircleCheckBig color='#239f38' size={16} /> Tarnos
											<br />
											<CircleCheckBig color='#239f38' size={16} /> Saint-Paul-lès-Dax
											<br />
											<CircleCheckBig color='#239f38' size={16} /> Capbreton
											<br />
											<CircleCheckBig color='#239f38' size={16} /> Parentis-en-Born
											<br />
											<CircleCheckBig color='#239f38' size={16} /> Mimizan
											<br />
											<CircleCheckBig color='#239f38' size={16} /> Saint-Vincent-de-Tyrosse
											<br />
											<CircleCheckBig color='#239f38' size={16} /> Soustons
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					<br />
					<div class='card text-bg-danger bg-gradient mb-3' style={{ maxWidth: '73rem' }}>
						<div class='card-body'>
							<h5 class='card-title'>🚗 Intervention Rapide</h5>
							<p class='card-text'>
								Nous intervenons dans toute la région : Bayonne, Pau, Dax, Biarritz, Mont-de-Marsan, Oloron-Sainte-Marie, Orthez et toutes les villes
								environnantes.
							</p>
							<div class='container'>
								<div class='row justify-content-evenly'>
									<div class='col-4'>
										<div class='card bg-light p-2 text-white bg-opacity-25 border border-0' style={{ width: '18rem' }}>
											<div class='card-body'>
												<h5 class='card-title'>
													⚡
													<br />
													Dépannage 24/7
												</h5>
												<h6 class='card-subtitle mb-2 text-white'>Tous départements</h6>
											</div>
										</div>
									</div>

									<div class='col-4'>
										<div class='card bg-light p-2 text-white bg-opacity-25 border border-0' style={{ width: '18rem' }}>
											<div class='card-body'>
												<h5 class='card-title'>
													📦
													<br />
													Vide maison
												</h5>
												<h6 class='card-subtitle mb-2 text-white'>Débarras complet</h6>
											</div>
										</div>
									</div>
								</div>
							</div>
							<br />
							<button type='button' class='btn btn-light'>
								<NavLink
									to='/Contact'
									style={({ isActive, isPending }) => {
										return {
											color: isActive ? 'red' : 'red',
											textDecoration: isActive ? 'none' : 'none',
										};
									}}
								>
									Demander une intervention
								</NavLink>
							</button>
							<br />
						</div>
					</div>
					<br />
					<div class='shadow card text-bg-light mb-3' style={{ maxWidth: '73rem' }}>
						<div class='card-body'>
							<h5 class='card-title'>Votre ville n'est pas dans la liste ?</h5>
							<p class='card-text'>Contactez-nous ! Nous étudions toutes les demandes dans les départements 64 et 40.</p>
							<br />
							<button type='button' class='btn btn-danger'>
								<a href='tel:0618767935' style={{ color: '#fcfcfc', textDecoration: 'none' }}>
									📞 06 18 76 79 35
								</a>
							</button>
						</div>
					</div>
					<br />
					<h2>
						<span class='badge rounded-pill text-danger text-bg-danger bg-opacity-50'>Notre Expertise</span>
					</h2>
					<br />
					<h1>Nos interventions en images</h1>
					<br />
					<p>Découvrez nos différents services en action</p>
					<br />
					<div class='container text-center'>
						<div class='row'>
							<div class='col-sm card border-0'>
								<img
									src='https://images.unsplash.com/photo-1742069028875-93c524b6fa95?crop=entropy&amp;cs=tinysrgb&amp;fit=max&amp;fm=jpg&amp;ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjYXIlMjB0b3dpbmclMjB0cnVja3xlbnwxfHx8fDE3NjE2NDAxMDl8MA&amp;ixlib=rb-4.1.0&amp;q=80&amp;w=1080&amp;utm_source=figma&amp;utm_medium=referral'
									alt='Dépannage auto'
									class='card-img rounded-4 img-thumbnail'
									style={{ width: '400px', height: '200px' }}
								/>
								<div class='card-img-overlay text-light text-start'>
									<br />
									<br />
									<br />
									<br />
									<br />
									<h5 class='card-title ms-2'>
										<span class='badge text-bg-danger'>Dépannage</span>
									</h5>
									<p class='card-text fw-bold ms-2'>Dépannage auto</p>
								</div>
							</div>
							<div class='col-sm card border-0'>
								<img
									src='https://images.unsplash.com/photo-1642225062426-c9f9610de7c5?crop=entropy&amp;cs=tinysrgb&amp;fit=max&amp;fm=jpg&amp;ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtb3RvcmN5Y2xlJTIwdG93aW5nfGVufDF8fHx8MTc2MTY0MDQ3Nnww&amp;ixlib=rb-4.1.0&amp;q=80&amp;w=1080&amp;utm_source=figma&amp;utm_medium=referral'
									alt='Dépannage moto'
									class=' card-img rounded-4 img-thumbnail'
									style={{ width: '400px', height: '200px' }}
								/>
								<div class='card-img-overlay text-light text-start'>
									<br />
									<br />
									<br />
									<br />
									<br />
									<h5 class='card-title ms-2'>
										<span class='badge text-bg-danger'>Dépannage</span>
									</h5>
									<p class='card-text fw-bold ms-2'>Dépannage moto</p>
								</div>
							</div>
							<div class='col-sm card border-0'>
								<img
									src='https://images.unsplash.com/photo-1611943159029-d9e5a69756da?crop=entropy&amp;cs=tinysrgb&amp;fit=max&amp;fm=jpg&amp;ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxqdW5rJTIwY2FycyUyMHNjcmFweWFyZHxlbnwxfHx8fDE3NjE2NDAxMTB8MA&amp;ixlib=rb-4.1.0&amp;q=80&amp;w=1080&amp;utm_source=figma&amp;utm_medium=referral'
									alt='Épaviste agréé'
									class='card-img rounded-4 img-thumbnail'
									style={{ width: '400px', height: '200px' }}
								/>
								<div class='card-img-overlay text-light text-start'>
									<br />
									<br />
									<br />
									<br />
									<br />
									<h5 class='card-title ms-2'>
										<span class='badge text-bg-danger'>Épaviste</span>
									</h5>
									<p class='card-text fw-bold ms-2'>Épaviste agréé</p>
								</div>
							</div>
						</div>
						<br />
						<div class='row'>
							<div class='col-sm card border-0'>
								<img
									src='https://images.unsplash.com/photo-1675736897098-20f99824dfee?crop=entropy&amp;cs=tinysrgb&amp;fit=max&amp;fm=jpg&amp;ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxyZWN5Y2xpbmclMjBtZXRhbCUyMGNhcnxlbnwxfHx8fDE3NjE2NDAxMTB8MA&amp;ixlib=rb-4.1.0&amp;q=80&amp;w=1080&amp;utm_source=figma&amp;utm_medium=referral'
									class='card-img rounded-4 img-thumbnail'
									alt='Recyclage véhicules'
									style={{ width: '400px', height: '200px' }}
								/>
								<div class='card-img-overlay text-light text-start'>
									<br />
									<br />
									<br />
									<br />
									<br />
									<h5 class='card-title ms-2'>
										<span class='badge text-bg-danger'>Épaviste</span>
									</h5>
									<p class='card-text fw-bold ms-2'>Recyclage véhicules</p>
								</div>
							</div>
							<div class='col-sm card border-0'>
								<img
									src='https://images.unsplash.com/photo-1562534315-64dba645d0f9?crop=entropy&amp;cs=tinysrgb&amp;fit=max&amp;fm=jpg&amp;ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxob3VzZSUyMG1vdmluZyUyMGZ1cm5pdHVyZXxlbnwxfHx8fDE3NjE2NDA0NzZ8MA&amp;ixlib=rb-4.1.0&amp;q=80&amp;w=1080&amp;utm_source=figma&amp;utm_medium=referral'
									class='card-img rounded-4 img-thumbnail'
									alt='Vide maison'
									style={{ width: '400px', height: '200px' }}
								/>
								<div class='card-img-overlay text-light text-start'>
									<br />
									<br />
									<br />
									<br />
									<br />
									<h5 class='card-title ms-2'>
										<span class='badge text-bg-danger'>Débarras</span>
									</h5>
									<p class='card-text fw-bold ms-2'>Vide maison</p>
								</div>
							</div>
							<div class='col-sm card border-0'>
								<img
									src='https://images.unsplash.com/photo-1729628371767-7a833756b8b5?crop=entropy&amp;cs=tinysrgb&amp;fit=max&amp;fm=jpg&amp;ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxqdW5rJTIwcmVtb3ZhbCUyMHRydWNrfGVufDF8fHx8MTc2MTY0MDQ3Nnww&amp;ixlib=rb-4.1.0&amp;q=80&amp;w=1080&amp;utm_source=figma&amp;utm_medium=referral'
									class='card-img rounded-4 img-thumbnail'
									alt='Évacuation encombrants'
									style={{ width: '400px', height: '200px' }}
								/>
								<div class='card-img-overlay text-light text-start'>
									<br />
									<br />
									<br />
									<br />
									<br />
									<h5 class='card-title ms-2'>
										<span class='badge text-bg-danger'>Débarras</span>
									</h5>
									<p class='card-text fw-bold ms-2'>Évacuation encombrants</p>
								</div>
							</div>
						</div>
					</div>
					<br />
					<p>Besoin d'un dépannage, d'enlever une épave ou de vider une maison ?</p>
					<br />
					<button type='button' class='btn btn-danger btn-lg'>
						<NavLink
							to='/Contact'
							style={({ isActive, isPending }) => {
								return {
									color: isActive ? 'white' : 'white',
									textDecoration: isActive ? 'none' : 'none',
								};
							}}
						>
							Contactez-nous maintenant
						</NavLink>
					</button>
				</center>
				<br />
				<br />
				<Footer></Footer>
			</div>
		);
};

export default Services;
